import { z } from "zod";

export const LoginSchema = z.object({
  mail: z.email("Please enter a valid email address"),
  password: z.string({
    error: (issue) => issue.input === undefined
      ? "Password is required"
      : "Password must be a string"
  })
});

export const LoginDefaultValues = {
  mail: "",
  password: "",
};

// Infer the TypeScript type from the Zod schema
export type TLoginSchema = z.infer<typeof LoginSchema>;
